export default "__VITE_ASSET__5f26c00e__$_?nuxt_component=async&nuxt_component_name=SvgoBrush__"